import React from 'react';

const TableContext = React.createContext(null);

export default TableContext;
